import React, { useContext, useLayoutEffect } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../common/PrivateRoute";
import Login from "../login/Login";
import ForgotPassword from "../login/ForgotPassword";
import { NavBar } from "../common/views/NavBar";
import { HomeScreen } from "../home/HomeScreen";
import { AuthContext } from "../providers/AuthProvider";
import { UserIndex } from "../user/UserIndex";
import { OperationScreen } from "../operation/OperationScreen";
import { LotScreen } from "../lot/LotScreen";
import ReserveIndex from "../reserve/ReserveIndex";
import { NotFoundScreen } from "../home/NotFound";
import { UserAdminScreen } from "../user/UserAdminScreen";
import { AppVersionIndex } from "../app-version/AppVersionIndex";
import { AppVersionList } from "../app-version/AppVersionList";
import { MessageIndex } from "../message/MessageIndex";
import { MessageList } from "../message/MessageList";
import Loader from "../common/views/Loader";
import { useAlert } from "react-alert";
import { ChangePasswordScreen } from "../user/ChangePasswordScreen";
import ApiHelper from "../api/ApiHelper";

export const Routes = () => {
  const { user, isLoading, isUserExpired, isAdmin } = useContext(AuthContext);
  const alert = useAlert();

  useLayoutEffect(() => {
    const onVisibilityChange = (e) => {
      isUserExpired().then((currentUser) => {
        if (user && !currentUser) {
          alert.info("La session a expiré");
        }
      });
    };

    window.addEventListener("focus", onVisibilityChange);

    return () => {
      window.removeEventListener("focus", onVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const isUserAdmin = isAdmin();

  if (isLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center flex-grow-1">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {user && <NavBar />}
      <div className="route-content">
        {isUserAdmin && (
          <Switch>
            <Route path={`/login`} component={Login} />
            <Route path={`/recover_password`} component={ForgotPassword} />
            <PrivateRoute path={"/"} exact component={HomeScreen} />
            <PrivateRoute
              path={"/expired_password"}
              exact
              component={ChangePasswordScreen}
            />
            <PrivateRoute
              path={"/operation/:operationId/lot/:id"}
              component={LotScreen}
            />
            <PrivateRoute
              path={"/operation/:operationId"}
              component={OperationScreen}
            />

            <PrivateRoute
              path={"/reserve/:id/copy"}
              exact
              component={(props) => <ReserveIndex copy={true} {...props} />}
            />
            <PrivateRoute
              path={"/reserve/:id"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/:idLot"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/ct/:idCleTransverse"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/ct/:idCleTransverse/:idSalesforce"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/operation/:idOperation"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute path={"/user/:id"} component={UserIndex} />
            <PrivateRoute path={"/user"} component={UserAdminScreen} />
            <PrivateRoute
              path={"/app-version/:id"}
              component={AppVersionIndex}
            />
            <PrivateRoute path={"/app-version"} component={AppVersionList} />
            <PrivateRoute path={"/message/:id"} component={MessageIndex} />
            <PrivateRoute path={"/message"} component={MessageList} />
            <Route path="*" component={NotFoundScreen} />
          </Switch>
        )}

        {!isUserAdmin && (
          <Switch>
            <Route path={`/login`} component={Login} />
            <Route path={`/recover_password`} component={ForgotPassword} />
            <PrivateRoute path={"/"} exact component={HomeScreen} />
            <PrivateRoute
              path={"/expired_password"}
              exact
              component={ChangePasswordScreen}
            />
            <PrivateRoute
              path={"/operation/:operationId/lot/:id"}
              component={LotScreen}
            />
            <PrivateRoute
              path={"/operation/:operationId"}
              component={OperationScreen}
            />

            <PrivateRoute path={"/user/:id"} component={UserIndex} />
            <PrivateRoute
              path={"/reserve/:id/copy"}
              exact
              component={(props) => <ReserveIndex copy={true} {...props} />}
            />
            <PrivateRoute
              path={"/reserve/:id"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/:idLot"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/ct/:idCleTransverse"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/ct/:idCleTransverse/:idSalesforce"}
              exact
              component={ReserveIndex}
            />
            <PrivateRoute
              path={"/reserve/new/operation/:idOperation"}
              exact
              component={ReserveIndex}
            />
            <Route path="*" component={NotFoundScreen} />
          </Switch>
        )}
      </div>
    </>
  );
};
